<template>
  <section class="how-works-in-body bg-white">
    <div class="lightblue-bg">
      <b-container>
        <b-row>
          <b-col class="px-0">
            <div class="contents text-center mx-auto">
              <h2 class="mb-4 pb-4 mb-lg-4 pb-lg-2 mx-lg-5 px-lg-5">
                JORNAY PM provides smooth and steady coverage from morning into
                the evening.
              </h2>
              <p class="dark-text mx-lg-5 fw-semibold unique-formulation-text">
                Because of its unique formulation, JORNAY PM provides ADHD symptom
                support upon waking and throughout the day without the need for a
                short-acting booster.* This means no sudden medication spikes. Dosage 
                time and duration of therapeutic effect may vary from patient to patient.
              </p>
              <figure class="mx-lg-4 how-works-figure">
                <img
                  src="@/assets/images/3_25/how/chart@2x.webp"
                  alt="Line graph showing dosing time and duration of effect throughout the day."
                  title="Line graph showing dosing time and duration of effect throughout the day."
                />
                <figcaption class="text-dark disclaimer fw-semibold therapeutic-text">
                  <div class="mt-3">
                    <p>
                      The therapeutic level of JORNAY PM is the minimum level at
                      which the amount of drug in the bloodstream is expected to
                      have a desired effect. This graph is for illustrative purposes only. Therapeutic
                      level differs between patients.
                    </p>

                    <p class="text-asterisk">
                      <span class="asterisk">
                        *
                      </span>
                      <!-- <span> -->
                        In clinical studies, children and adolescents were not given an afternoon booster.
                      <!-- </span> -->
                    </p>
                  </div>
                </figcaption>
              </figure>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </section>
</template>

<script>
export default {
  name: "HowWorksInBody",
};
</script>
